import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { RestfulService } from 'src-ironside/services/restful.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { Filter } from './common.repository';
import { downloadBlob } from 'src-ironside/helpers/file';
import { DynamicViewInfoService } from 'src/app/shared/services/dynamic-view-info.service';

const COLLECTION_NAME = 'dynamic_legal_entity';

export type Partner = {
    id: string;
    title?: string;
    phone?: string;
    fax?: string;
    email?: string;
    city?: string;
    code: string;
    logo: string;
    resources?: string[];
    status?:any
};

@Injectable()
export class PartnerRepository extends RestfulService {
    constructor(
        public override httpClient: HttpClient,
        public override router: Router,
        private dynamicDocumentService: DynamicDocumentService,
        private dynamicViewService: DynamicViewInfoService
    ) {
        super(httpClient, router);
    }

    defaultFilters: Filter[] = [
        {
            fieldName: 'status',
            conditions: [
                {
                    type: 'EQUALS',
                    value: 'ACTIF',
                },
            ],
        },
        {
            fieldName: 'typeOfLegalEntity',
            conditions: [
                {
                    type: 'EQUALS',
                    value: 'PARTENAIRE',
                },
            ],
        },
    ];

    find(
        page = 1,
        pageSize = 150,
        direction: 'ASC' | 'DESC' = 'DESC',
        companyName: string = ''
    ): Observable<{ content: Partner[]; totalElements: number }> {
        const filter: Filter[] = [
            ...this.defaultFilters,
            {
                fieldName: 'companyName',
                conditions: [
                    {
                        type: 'CONTAINS',
                        value: companyName,
                    },
                ],
            },
        ];
        return this.doPost(`dynamic-documents/${COLLECTION_NAME}/search`, {
            collectionName: COLLECTION_NAME,
            filters: filter,
            page: page,
            pageSize: pageSize,
            sorts: {
                publishedOrder: direction,companyName:'ASC'

            },
        }).pipe(
            map((res) => {
                return {
                    content: res.content.map((partner: any) => ({
                        id: partner.id,
                        title: partner.companyName,
                        phone: partner.phone,
                        fax: partner.fax,
                        email: partner.email,
                        city: partner.city,
                        code: partner.code,
                        resources: partner.linkToResources?.map(
                            (resource: any) => resource.documentId
                        ),
                        logo: partner?.logo?.[0]?.url,
                        status:partner.status,
                    })),
                    totalElements: res.totalElements,
                };
            })
        );
    }

    findSelection(
        page = 1,
        pageSize = 24,
        direction: 'ASC' | 'DESC' = 'ASC'
    ): Observable<{
        content: Partner[];
        meta: { totalPages: number; pageSize: number; totalItems: number };
    }> {
        const filter: Filter[] = [...this.defaultFilters];
        return this.doPost(`dynamic-documents/${COLLECTION_NAME}/search`, {
            collectionName: COLLECTION_NAME,
            filters: filter,
            page: page,
            pageSize: pageSize,
            sorts: {
                companyName: direction,
            },
        }).pipe(
            map((res) => {
                return {
                    content: res.content.map((partner: any) => ({
                        id: partner.id,
                        title: partner.companyName,
                        code: partner.code,
                        resources: partner.linkToResources?.map(
                            (resource: any) => resource.documentId
                        ),
                    })).sort((a: any, b: any) => a.title.localeCompare(b.title)),
                    meta: {
                        pageSize: res.size,
                        totalPages: res.totalPages,
                        totalItems: res.totalElements,
                    },
                };
            })
        );
    }

    getDetailPartner(
        page = 1,
        pageSize = 150,
        direction: 'ASC' | 'DESC' = 'DESC',
        partnerId: string = ''
    ) {
        const filters: Filter[] = [
            {
                fieldName: 'code',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: partnerId,
                    },
                ],
            },
        ];
        return this.dynamicDocumentService
            .find(
                {
                    collectionName: COLLECTION_NAME,
                    filters: filters,
                    page: page,
                    pageSize: pageSize,
                    sorts: {
                        publishedOrder: direction,
                    },
                },

                true
            )
            .pipe(map((res) => res.content));
    }

    getContacts(ids: string[]) {
        return this.doPost(`view/filtrerById/dynamic_natural_person`, ids).pipe(
            map((res) => res.response)
        );
    }

    getViews() {
        return this.dynamicViewService.findByDocumentName(COLLECTION_NAME, false);
    }

    export(viewId: string) {
        this.dynamicDocumentService
          .exportFileSupplierOnView(COLLECTION_NAME, viewId, {
            ids: [],
            filters: [
                      ...this.defaultFilters.map((filter: Filter) => {
                          return {
                              conditions: [
                                  {
                                      type: 'EQUALS',
                                      valeurMin: '',
                                      value: filter.conditions[0].value,
                                      valeurMax: '',
                                  },
                              ],
                              fieldName: filter.fieldName,
                          };
                      }),
                  ],
            locales: ["fr_FR"],
            isUseLabel:"true"
        }).subscribe((data: Blob) => {
          downloadBlob(data, 'xlsx');
        });
    }
}
